import stateStats from "./stateStats.json";

export const nationalStats = stateStats['USA'];